export const GIVING_BASKET_SUB_TYPE = 'GIVING';
export const PAYMENT_BASKET_SUB_TYPE = 'PAYMENT';
export const SUSPEND_BASKET_SUB_TYPE = 'SUSPEND';
export const GIVING_BASKETS = 'givingBaskets';
export const PAYMENT_BASKETS = 'paymentBaskets';
export const SUSPEND_BASKETS = 'suspendBaskets';
export const INACTIVE_BASKETS = 'inactiveBaskets';
